// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"f178236f","453":"f3487ca5","734":"ab6ea9d6","763":"5d352c16","849":"5200df62","908":"baba1482"}[chunkId] + ".chunk.js";
};